import Const from 'constants';
import Action from 'actions';

let Lineup = {
    checkLineup(lineupId, checked) {
        return {
            type: Const.LINEUP_SET_IS_CHECKED,
            lineupId,
            checked,
        };
    },

    removeLineup(lineupId) {
        return (dispatch, getState) => {
            dispatch({
                type: Const.LINEUP_REMOVE,
                lineupId,
            });
            dispatch(this.setLineupsUsedPlayers());
        };
    },
};

export default Object.assign(Action, Lineup);
